module.exports = __webpack_public_path__ + "static/media/noproduct.56f5b94d.png";